import { createSlice } from '@reduxjs/toolkit';
import { publishProject } from 'shared/thunks/admin/publishProject';
import { updateProjectConfig } from 'shared/thunks/admin/updateProjectConfig';

const initialState = false;

const loaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    showLoader() {
      return true;
    },
    hideLoader() {
      return false;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(updateProjectConfig.pending, () => {
        return true;
      })
      .addCase(updateProjectConfig.fulfilled, () => {
        return false;
      })
      .addCase(updateProjectConfig.rejected, () => {
        return false;
      })
      .addCase(publishProject.pending, () => {
        return true;
      })
      .addCase(publishProject.fulfilled, () => {
        return false;
      })
      .addCase(publishProject.rejected, () => {
        return false;
      });
  },
});

export const { showLoader, hideLoader } = loaderSlice.actions;
export const loaderReducer = loaderSlice.reducer;
